import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

const SurveyIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    backColor?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.width ?? 37} height={props.height ?? 37} viewBox="0 0 37 37" fill="none">
          <Rect
            x="0.667969"
            y="0.800781"
            width="35"
            height="35"
            rx="7.5"
            fill={props.backColor ?? '#FFF5DD'}
          />
          <Rect x="0.667969" y="0.800781" width="35" height="35" rx="7.5" stroke="#FCEABB" />
          <G clipPath="url(#clip0_3741_32683)">
            <Path
              d="M30.168 28.8008H8.04102V28.7968C7.52344 28.7968 7.05469 28.5828 6.7168 28.24C6.38086 27.8992 6.17188 27.4256 6.17188 26.9025H6.16797V7.80078H8.5625V26.3734H30.168V28.8008ZM22.4512 16.8364H26.2695C26.4727 16.8364 26.6387 17.0049 26.6387 17.211V24.8318C26.6387 25.0379 26.4727 25.2063 26.2695 25.2063H22.4512C22.248 25.2063 22.082 25.0379 22.082 24.8318V17.2129C22.082 17.0069 22.248 16.8364 22.4512 16.8364ZM11.1211 12.174H14.9395C15.1426 12.174 15.3086 12.3424 15.3086 12.5485V24.8338C15.3086 25.0399 15.1426 25.2083 14.9395 25.2083H11.1211C10.918 25.2083 10.752 25.0399 10.752 24.8338V12.5485C10.752 12.3424 10.918 12.174 11.1211 12.174ZM16.7871 9.55045H20.6035C20.8066 9.55045 20.9727 9.71888 20.9727 9.92496V24.8338C20.9727 25.0399 20.8066 25.2083 20.6035 25.2083H16.7871C16.584 25.2083 16.418 25.0399 16.418 24.8338V9.92496C16.418 9.71888 16.584 9.55045 16.7871 9.55045Z"
              fill={props.color ?? '#E2753A'}
            />
          </G>
          <Defs>
            <ClipPath id="clip0_3741_32683">
              <Rect width="24" height="21" fill="white" transform="translate(6.16797 7.80078)" />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { SurveyIcon };
